import { createApiMutationHook, IApiMutationFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ILocationResource } from "../types";

export type ILocationUpdateMutationParameters = {
    location: RelationalValue<ILocationResource>;
    title: string;
    isDefault?: boolean;
};

export type ILocationUpdateMutationResult = ILocationResource;

export const locationUpdateMutation: IApiMutationFunction<ILocationUpdateMutationParameters> = ({
    location,
    title,
    isDefault,
}) => {
    return {
        method: "PUT",
        url: `/locations/${mapRelationalValue(location)}`,
        data: {
            title,
            isDefault,
        },
    };
};

export const useLocationUpdateMutation = createApiMutationHook<
    ILocationUpdateMutationParameters,
    ILocationUpdateMutationResult
>(locationUpdateMutation);
